<script setup>
import { PanelLeft } from "lucide-vue-next";
import { cn } from "@/lib/utils";
import { Button } from '@/components/ui/button';
import { useSidebar } from "./utils";
import { useI18n } from 'vue-i18n';

const props = defineProps({
  class: { type: null, required: false },
});

const { toggleSidebar, open } = useSidebar();
const { t } = useI18n();
</script>

<template>
  <Button
    :style="`margin-left: ${open ? 5 : 0}px`"
    data-sidebar="trigger"
    variant="ghost"
    size="icon"
    :class="cn('h-7 w-7', props.class)"
    @click="toggleSidebar"
  >
    <PanelLeft />
    <span v-if="open" style="width: 1px">{{ t('view.collapse') }}</span>
  </Button>
</template>
